import { render, staticRenderFns } from "./FooterLegal.vue?vue&type=template&id=1eb9b9c6&scoped=true"
import script from "./FooterLegal.vue?vue&type=script&lang=js"
export * from "./FooterLegal.vue?vue&type=script&lang=js"
import style0 from "./FooterLegal.vue?vue&type=style&index=0&id=1eb9b9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb9b9c6",
  null
  
)

export default component.exports